package com.anjuros.website.templates.template8.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText

import com.anjuros.website.templates.selection.styles.HeaderHeight

import com.anjuros.website.templates.template8.util.Template8Constants.FONT_FAMILY
import com.anjuros.website.templates.template8.components.Template8Header
import com.anjuros.website.templates.template8.styles.Template8Theme
import com.anjuros.website.templates.template8.styles.getColor
import com.anjuros.website.templates.template8.util.ResKey
import com.anjuros.website.templates.template8.util.Template8Constants
import com.anjuros.website.templates.template8.util.Template8Res
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template8MainSection(
    modifier: Modifier = Modifier.fillMaxWidth(),
    clickable:Boolean = true,
    onMenuCLicked: () -> Unit ={},
) {
    Box(
        modifier = modifier
            .id("home")
            .fillMaxWidth(),
        contentAlignment = Alignment.TopCenter
    ) {

        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Template8Header(
                onMenuCLicked=onMenuCLicked,
                clickable = clickable
            )
            GoldLine()
            MainContent()
            GoldLine()

        }

        AnjurosLogo(
            modifier = Modifier

                .align(Alignment.TopCenter)
                .margin(top = 20.px)
                .size(150.px)
                .objectFit(ObjectFit.ScaleDown),
            src = Template8Res.Image.template8_logo,
            alt = "Pub menu"
        )

    }
}

@Composable
fun GoldLine(){
    Image(
        modifier = Modifier.fillMaxWidth()
            .height(3.px)
            .objectFit(ObjectFit.Cover),
        src = Template8Res.Image.template8_line,
        alt = "Pub menu"
    )
}

@Composable
fun MainContent(){

    var animatedTranslation = remember { mutableStateOf((30).percent) }
    var scope = rememberCoroutineScope()

    scope.launch {
        delay(300)
        animatedTranslation.value = 0.percent
    }



    Box(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        AnjurosImage(
            modifier = Modifier.fillMaxWidth()
                .displayIfAtLeast(Breakpoint.LG)
                .height(600.px)
                .align(Alignment.Center)
                .objectFit(ObjectFit.Cover),
            src = Template8Res.Image.template8_main_background,
            alt = "Red Lion"
        )
        AnjurosImage(
            modifier = Modifier.fillMaxWidth()
                .displayUntil(Breakpoint.LG)
                .height(600.px)
                .align(Alignment.Center)
                .objectFit(ObjectFit.Cover),
            src = Template8Res.Image.template8_main_background,
            alt = "Red Lion"
        )
        Column(
            modifier = Modifier
                .align(Alignment.Center)
                .backgroundColor(Template8Theme.DarkGrey.rgb)
                .padding(30.px)
                .margin(bottom = 20.px),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            P(
                attrs = Modifier
                    .margin(topBottom = 0.px)
                    .fontFamily(FONT_FAMILY)
                    .textAlign(TextAlign.Center)
                    .translateY(ty = animatedTranslation.value)
                    .transition(
                        Transition.of(property = "translate", duration = 1000.ms))
                    .fontSize(48.px)
                    .fontWeight(FontWeight.Bold)
                    .fontStyle(FontStyle.Italic)
                    .color(Template8Theme.Primary.getColor())
                    .toAttrs()
            ) {
                AnjurosText("The ", com.anjuros.website.components.language.ResKey.PLACEHOLDER_COMPANY_NAME)

                Span(
                    attrs = Modifier
                        .color(rgb(205, 47, 34)) // pure red
                        .toAttrs()
                ) {
                    AnjurosText("Red", com.anjuros.website.components.language.ResKey.PLACEHOLDER_EMPTY)
                }

                AnjurosText(" Lion", com.anjuros.website.components.language.ResKey.PLACEHOLDER_EMPTY)
            }
            P(
                attrs = Modifier
                    .margin(topBottom =0.px)
                    .fontFamily(FONT_FAMILY)
                    .translateY(ty = animatedTranslation.value)
                    .transition(
                        Transition.of(property = "translate", duration = 1200.ms, delay = 400.ms))
                    .fontSize(25.px)
                    .fontWeight(FontWeight.Normal)
                    .color(Template8Theme.Gold2.rgb)
                    .toAttrs()
            ) {
                Text(LocalText(ResKey.TEMPLATE8_SLOGAN))

            }
        }

    }
}